import React from "react";
import IcoMoon from "react-icomoon";
const iconSet = require("./selection.json");


const Icon = ({ ...props }) => {
     return <IcoMoon iconSet={iconSet} style={{ height: '24px', width:"24px", color:"inherit"}} className="icon" {...props} />;
};

export default Icon;